import styled from 'styled-components';
import Maps from 'gatsby-theme-core/src/components/maps';

export default styled(Maps)`
  margin-bottom: -60px;
  height: 350px;
`;
